<template>
    <modal v-if="isBadgesModal" @close="isBadgesModal=!isBadgesModal" class="updateProfileModal badgemodal">
        <div slot="closeModal" @click="isBadgesModal=!isBadgesModal">
             <img src="../../assets/icon/close-gray.svg" />
        </div>
        <div slot="header">
            <h2>Your Badges</h2>
            <p>Choose which badge you want to show next to your name:</p>
        </div>
        <div slot="body">

            <!-- general badge start -->
            <div class="badge-wrap">
                <div class="badge-title">
                    <h3>General Badges</h3>
                </div>
                <div class="badge-icon-wrap">
                    <div v-for="data in verifiedIcon" 
                         :key="data.id"
                         :class="{ 'selected': data.selected }"
                         @click="data.selected=!data.selected"
                         class="badge-single-icon">
                        <img :src="require(`@/assets/images/badges/${data.icon}`)" :alt="data.title" />
                        <p>{{ data.title }}</p>
                    </div>
                </div>
            </div>
            <!-- general badge end -->

            <!-- writing badge start -->
            <div class="badge-wrap">
                <div class="badge-title">
                    <h3>Writing Badges</h3>
                </div>
                <div class="badge-icon-wrap">
                    <div v-for="data in writingBadge" 
                         :key="data.id"
                         :class="{ 'selected': data.selected }"
                         @click="data.selected=!data.selected"
                         class="badge-single-icon">
                        <img :src="require(`@/assets/images/badges/${data.icon}`)" :alt="data.title" />
                        <p>{{ data.title }}</p>
                    </div>
                </div>
            </div>
            <!-- writing badge end -->

            <!-- profile badge start -->
            <div class="badge-wrap">
                <div class="badge-title">
                    <h3>Profile Badges</h3>
                </div>
                <div class="badge-icon-wrap">
                    <div v-for="data in profileBadge" 
                         :key="data.id"
                         :class="{ 'selected': data.selected }"
                         @click="data.selected=!data.selected"
                         class="badge-single-icon">
                        <img :src="require(`@/assets/images/badges/${data.icon}`)" :alt="data.title" />
                        <p>{{ data.title }}</p>
                    </div>
                </div><!-- /.badge-icon-wrap -->
            </div>
            <!-- profile badge end -->


            <!-- profile badge start -->
            <div class="badge-wrap">
                <div class="badge-title">
                    <h3>Reading Badges</h3>
                </div>
                <div class="badge-icon-wrap">
                    <div v-for="data in readingBadge" 
                         :key="data.id"
                         :class="{ 'selected': data.selected }"
                         @click="data.selected=!data.selected"
                         class="badge-single-icon">
                        <img :src="require(`@/assets/images/badges/${data.icon}`)" :alt="data.title" />
                        <p>{{ data.title }}</p>
                    </div>
                </div><!-- /.badge-icon-wrap -->
            </div>
            <!-- profile badge end -->

            <div class="badge-wrap">
                <div class="badge-title">
                    <h3>Progress</h3>
                </div>

                <div class="progress-wrap">
                    <div class="single-progress-badge">
                        <div class="single-badge-content">
                            <h3>Elite Comma</h3>
                            <span>Comment on stories!</span>
                        </div>
                        <div class="progress-bar">
                            <div class="inner-progress-bar" style="width: 25%"></div>
                        </div>
                    </div><!--  /. single-progress-badge -->

                    <div class="single-progress-badge">
                        <div class="single-badge-content">
                            <h3>Avide Reader</h3>
                            <span>Keep reading!</span>
                        </div>
                        <div class="progress-bar">
                            <div class="inner-progress-bar" style="width: 40%"></div>
                        </div>
                    </div><!--  /. single-progress-badge -->

                    <div class="single-progress-badge">
                        <div class="single-badge-content">
                            <h3>Bronze Comma</h3>
                            <span>Keep reading!</span>
                        </div>
                        <div class="progress-bar">
                            <div class="inner-progress-bar" style="width: 70%"></div>
                        </div>
                    </div><!--  /. single-progress-badge -->

                    <div class="single-progress-badge">
                        <div class="single-badge-content">
                            <h3>Commabassador</h3>
                            <span>Keep reading!</span>
                        </div>
                        <div class="progress-bar">
                            <div class="inner-progress-bar" style="width: 100%"></div>
                        </div>
                    </div><!--  /. single-progress-badge -->

                    <div class="single-progress-badge">
                        <p>Secret Writer Badges can be earned if your stories get a lot of likes and reads.</p>
                    </div><!--  /. single-progress-badge -->
                </div>
            </div><!-- /.badge-single -->
        </div>
        <div slot="footer">       
            <button class="profile modal-default-button" @click="saveData">Save</button>
        </div>
    </modal>
</template>


<script>

import { EventBus } from '../../main';
export default {
  name: "badges-modal",

  data() {
      return {
        isBadgesModal:false,
        verifiedIcon:[
            {
                id:1,
                icon: 'verified.svg',
                title: 'Verified',
                selected:true
            },
            {
                id:2,
                icon: 'award.png',
                title: 'Award Winner',
                selected:false
            }
        ],
        writingBadge:[
            {
                id:1,
                icon: 'gifted.svg',
                title: 'Gifted Writer',
                selected:false
            },
            {
                id:2,
                icon: 'Oval.png',
                title: 'Commaful Star',
                selected:false
            },
            {
                id:3,
                icon: 'light-star.svg',
                title: 'Commaful Star',
                selected:false
            }
        ],
        profileBadge:[
            {
                id:1,
                icon: 'commabassador.svg',
                title: 'Commabassador',
                selected:true
            },
            {
                id:2,
                icon: 'bronze.svg',
                title: 'Bronze Comma',
                selected:false
            },
            {
                id:3,
                icon: 'gold.svg',
                title: 'Gold Comma',
                selected:false
            },
            {
                id:4,
                icon: 'elite.svg',
                title: 'Elite Comma',
                selected:false
            }
        ],
        readingBadge:[
            {
                id:1,
                icon: 'power-reader.svg',
                title: 'Power Reader',
                selected:false
            },
            {
                id:2,
                icon: 'frequent-reader.svg',
                title: 'Frequent Reader',
                selected:false
            },
            {
                id:3,
                icon: 'avid-reader.svg',
                title: 'Avid Reader',
                selected:false
            }
        ]
      }
  }, 

  methods:{
    saveData() {
        this.isBadgesModal=false;
        this.$noty.success("Badge added successfully.");
    }
  },

  created() {
    // Badges modal
    EventBus.$on('badgemodal', data => {
        this.isBadgesModal=data;
    });



  }

}

</script>